import React, { useEffect, useState } from "react"
import { Radio } from "semantic-ui-react"
import ApplyRewards from "./ApplyRewards"
import {
  getEarnedMiles,
  getApplyMilesAndDiscount,
  applyRedeemMiles,
  resetMilesRewardsState
} from "../../../v1/actions/rewards"
import store from "../../../shared_component/utils/configureStore"
import Notifications from "../../../v1/components/Notifications"
import { connect } from "react-redux"
import { updateCart } from "../../../v1/actions/user"
import { convertCurrencyToNumber } from "../../../shared_component/constants/rewards"
import { withTranslation } from "react-i18next"

const RewardMilesPayment = ({
  getEarnedMiles,
  getApplyMilesAndDiscount,
  t,
  rewards,
  activeVehicleId
}) => {
  const { miles, discount, isMilesApplied } = rewards || {}
  const [openDialog, setOpenDialog] = useState(false)
  const [appliedMiles, setAppliedMiles] = useState(+miles || 0)
  const [earnedMiles, setEarnedMiles] = useState(0)
  const [redeemMilesIntoUSD, setRedeemedMilesIntoUSD] = useState(discount || 0)
  const [wantToApplyMiles, setWantToApplyMiles] = useState(isMilesApplied || false)
  const [milesPerDollar, setMilesPerDollar] = useState(0)

  const handleEarnedRewards = async () => {
    try {
      const rewardsRes = await getEarnedMiles()

      if (rewardsRes.error) {
        store.dispatch(
          Notifications.error({
            title: t("error"),
            message: `${rewardsRes.error}`,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
      } else {
        setEarnedMiles(rewardsRes.result.pending_miles.toString())
        !miles && !discount && setAppliedMiles(rewardsRes.result.pending_miles.toString())
      }
    } catch (error) {
      console.log(t("errorInHandledEarnedRewards"), error)
    }
  }

  const handleApplyMiles = async () => {
    try {
      const redeemMiles = await getApplyMilesAndDiscount({ miles: +appliedMiles })

      if (redeemMiles.error) {
        store.dispatch(
          Notifications.error({
            title: "Error",
            message: `${redeemMiles.error}`,
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
      } else {
        setRedeemedMilesIntoUSD(redeemMiles.result.amount)
        setMilesPerDollar(redeemMiles.result.miles_per_dollar)
      }
    } catch (error) {
      console.log(t("errorInHandleApplyMiles"), error)
    }
  }

  const handleCustomizeMiles = (miles, milesPerDiscount) => {
    setAppliedMiles(miles)
    wantToApplyMiles && saveToStore(miles.toString(), milesPerDiscount)
  }

  const saveToStore = (miles, milesperDiscount) => {
    const reducerObj = {
      miles: miles || appliedMiles,
      discount: milesperDiscount || redeemMilesIntoUSD,
      currencyInNumber: convertCurrencyToNumber(redeemMilesIntoUSD),
      isMilesApplied: true
    }

    store.dispatch(applyRedeemMiles(reducerObj))
    store.dispatch(
      updateCart(undefined, activeVehicleId, undefined, undefined, {
        redeem_miles: miles || appliedMiles
      })
    )
  }

  const resetRewardsStateRedux = () => {
    store.dispatch(resetMilesRewardsState())
    store.dispatch(
      updateCart(undefined, activeVehicleId, undefined, undefined, {
        redeem_miles: "0"
      })
    )
  }

  useEffect(() => {
    handleEarnedRewards()
  }, [])

  useEffect(() => {
    !!+appliedMiles && handleApplyMiles()
  }, [appliedMiles])

  return (
    <div className="rewards-miles-payment-container">
      <div className="rewards-toggle">
        {wantToApplyMiles ? (
          <p className="rewards-applied-miles">
            {appliedMiles} {t("milesHaveApplied")}
          </p>
        ) : (
          <p className="rewards-used-miles">
            {t("redeemAll")} {appliedMiles} {t("miles")}
          </p>
        )}
        <Radio
          className="rewards-toogle-checkbox"
          checked={wantToApplyMiles}
          disabled={!+appliedMiles}
          onChange={(e, { checked }) => {
            setWantToApplyMiles(checked)
            if (checked) {
              saveToStore()
            } else {
              resetRewardsStateRedux()
            }
          }}
          toggle
        />
      </div>
      <p className="rewards-applied-miles">
        {" "}
        = {redeemMilesIntoUSD} {t("orderTotal")}
      </p>
      <p className="rewards-customize-miles" onClick={() => +appliedMiles && setOpenDialog(true)}>
        {t("customizeMiles")}
      </p>
      <ApplyRewards
        handleCustomizeMiles={handleCustomizeMiles}
        setOpenDialog={setOpenDialog}
        openDialog={openDialog}
        earnedMiles={earnedMiles}
        appliedMiles={appliedMiles}
        milesPerDollar={milesPerDollar}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const user = state.user || {}
  const rewards = state.rewards

  return {
    rewards: rewards,
    activeVehicleId: user.activeVehicleId
  }
}

export default connect(mapStateToProps, { getEarnedMiles, getApplyMilesAndDiscount })(
  withTranslation("rewards")(RewardMilesPayment)
)
